import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Loading from "components/Loading";
import logoBraspag from "assets/images/logo.svg";
import { useState, useEffect } from "react";
import apiClient from "Api";
import { useSnackbar } from 'notistack';
import Alert from '@mui/material/Alert';
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

function ConfirmEmail() {
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { logout } = useAuth();

    let userId = searchParams.get('userId');
    let code = searchParams.get('code');

    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [emailConfirmed, setEmailConfirmed] = useState(false);
    const [errorOnConfirm, setErrorOnConfirm] = useState("");
    const [confirmResponse, setConfirmResponse] = useState(null);

    const savePassword = (e) => {
        e.preventDefault();
        if (password === "" || passwordConfirmation === "") {
            enqueueSnackbar("Senhas inválidas!", { variant: "error" });
        }
        else {
            if (password !== passwordConfirmation) {
                enqueueSnackbar("Senhas devem ser iguais!", { variant: "error" });
            }
            else {
                setIsLoading(true);
                apiClient.post(`/account/resetpassword/${confirmResponse.tenantId}`, { email: confirmResponse.email, resetCode: confirmResponse.resetToken, newPassword: passwordConfirmation })
                    .then(response => {
                        setIsLoading(false);
                        navigate(`/authentication/sign-in/${confirmResponse.tenantId}`);
                    }).catch(e => {
                        setIsLoading(false);
                        enqueueSnackbar("Erro ao cadastrar senha!", { variant: "error" });
                    });
            }
        }
    }

    function confirmEmailApi() {
        logout(false);
        if (userId !== "" && code !== "") {
            setIsLoading(true);
            apiClient.get(`/account/confirmemail?userId=${userId}&code=${code}`)
                .then(response => {
                    setIsLoading(false);
                    setEmailConfirmed(true);
                    setConfirmResponse(response.data);
                }).catch(e => {
                    setIsLoading(false);
                    setErrorOnConfirm("Erro ao confirmar conta!");
                });
        }
        else {
            setErrorOnConfirm("Parâmetros da url inválidos!");
        }
    }

    useEffect(() => {
        confirmEmailApi();
    }, []);

    return (
        <BasicLayout>
            <Loading isLoading={isLoading}></Loading>
            {errorOnConfirm !== "" &&
                < Alert severity="error" variant="outlined">
                    {errorOnConfirm}
                </Alert>
            }

            {!emailConfirmed && isLoading &&
                < Alert severity="warning" variant="outlined">
                    Aguarde, estamos confirmando sua conta...
                </Alert>
            }
            {emailConfirmed &&
                <Grid container spacing={3} p={4}>
                    <Grid item xs={12} md={12}>
                        <MDBox component="img" src={logoBraspag} alt="Brand" width="8rem" fullwidth="true" />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Card>
                            <MDBox
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                textAlign="center"
                            >
                                <MDTypography variant="h6" fontWeight="medium" color="white" p={1}>
                                    Cadastro de senha
                                </MDTypography>
                            </MDBox>
                            <MDBox p={4}>
                                <MDBox component="form" role="form" onSubmit={savePassword}>
                                    <MDBox mb={3}>
                                        <Alert severity="success" variant="outlined">
                                            Confirmação de e-mail concluída! <br />Cadastre sua senha para acessa o sistema!.
                                        </Alert>
                                    </MDBox>
                                    <MDBox mb={2}>
                                        <MDInput type="email" label="E-mail" value={confirmResponse.email} fullWidth disabled />
                                    </MDBox>
                                    <MDBox mb={2}>
                                        <MDInput type="password" label="Senha" value={password} fullWidth onChange={(event) => { setPassword(event.target.value); }} required />
                                    </MDBox>
                                    <MDBox mb={2}>
                                        <MDInput type="password" label="Confirmação de senha" value={passwordConfirmation} fullWidth onChange={(event) => { setPasswordConfirmation(event.target.value); }} required />
                                    </MDBox>
                                    <MDBox mt={4} mb={1}>
                                        <MDButton type="submit" variant="gradient" color="info" fullWidth>
                                            Salvar
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox >
                        </Card >
                    </Grid>
                </Grid>
            }
        </BasicLayout >
    );
}

export default ConfirmEmail;